import {Alert, Checkbox, Text, VStack} from '@chakra-ui/react';

interface PlazmaCopiesOptionProps {
    /** How many files are affected by the operation. */
    fileCount: number;
    /** How many of the affected web photos also have a plazma copy. */
    starredCount: number;
    /** What the opt-in does to the plazma copies alongside the web operation. */
    action: 'remove' | 'rename';
    checked: boolean;
    onChange: (checked: boolean) => void;
    /** The user may not delete the plazma copies, so removing them can't be chosen. */
    removeForbidden?: boolean;
}

/**
 * Warns that archiving/deleting/moving/renaming web photos would break their link to the
 * plazma copies (plazma should stay a subset of web, matched by name), with an opt-in to
 * also remove — or, for renames, rename — those copies.
 */
export function PlazmaCopiesOption({fileCount, starredCount, action, checked, onChange, removeForbidden}: PlazmaCopiesOptionProps) {
    const plural = starredCount > 1;
    const isLocked = action === 'remove' && !!removeForbidden;
    return <VStack align="stretch" gap={3} mt={3}>
        <Alert.Root status="warning" borderRadius="md" fontSize="sm">
            <Alert.Indicator/>
            <Alert.Title>
                {plural
                    ? `${starredCount} kijelölt kép a plazmában is szerepel.`
                    : fileCount === 1
                        ? 'Ez a kép a plazmában is szerepel.'
                        : `Egy kijelölt kép a plazmában is szerepel.`}
            </Alert.Title>
        </Alert.Root>
        <Checkbox.Root
            colorPalette="blue"
            checked={checked && !isLocked}
            disabled={isLocked}
            onCheckedChange={(e) => onChange(e.checked === true)}
        >
            <Checkbox.HiddenInput/>
            <Checkbox.Control/>
            <Checkbox.Label>
                {plural ? 'Plazmás másolatok' : 'Plazmás másolat'} {action === 'rename' ? 'átnevezése' : 'eltávolítása'}
            </Checkbox.Label>
        </Checkbox.Root>
        {isLocked &&
            <Text fontSize="sm" color="gray.500">Nincs jogosultságod a plazmás másolatok törléséhez.</Text>
        }
    </VStack>;
}
